export const PaymentEventDateType = {
  UNKNOWN: '0',
  DETERMINED: '1'
}

export const PaymentRefererType = {
  NO_ANSWER: '-1',
  WEB_SEARCH: '0',
  SNS: '1',
  FRIEND: '2',
  OTHER: '3'
}
